import { createSelector } from 'reselect'
import { makeCurrentUserSettingsSelector } from './currentUserSettings'
import { userDefaults } from 'store/redux/users'

export const getCurrentUser = (state, props) => {
  return state.kanbo.currentUser
}

export const getUser = (state, props) => {
  return state.kanbo.users[state.kanbo.currentUser.id] || { ...userDefaults }
}

export const makeCurrentUserSelector = () => {
  const currentUserSettingsSelector = makeCurrentUserSettingsSelector()

  return createSelector(
    [getCurrentUser, getUser, currentUserSettingsSelector],
    (currentUser, user, currentUserSettings) => {
      return {
        ...user,
        ...currentUser,
        settings: currentUserSettings
      }
    }
  )
}

export const currentUserSelector = makeCurrentUserSelector()
